import { UtilityLibModule } from './../utility-lib.module';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

// @Injectable({
//   providedIn: UtilityLibModule
// })
@Injectable()
export class JsontestService {

  private jsonTest: any = {
    information: {
      name: 'JSONTest',
      description: 'Simple testing for JSON-based applications.',
      mainUrl: 'jsontest.com'
    },
    servicesUrl: {
      dateTime: 'http://date.jsontest.com',
      echoJson: 'http://echo.jsontest.com/key/[key]/value/[value]',
      headers: 'http://headers.jsontest.com',
      ip: 'http://ip.jsontest.com',
      md5: 'http://md5.jsontest.com/?text=[text]',
      validateJson: 'http://validate.jsontest.com'
    }
  }

  constructor(
    private httpClient: HttpClient
  ) { }

  echoJson(key: string, value: string) {
    const url = this.jsonTest.servicesUrl.echoJson.replace('[key]', key).replace('[value]', value);
    return this.httpClient.get(url);
  }

  getDateTime() {
    return this.httpClient.get(this.jsonTest.servicesUrl.dateTime);
  }

  getHeaders() {
    return this.httpClient.get(this.jsonTest.servicesUrl.headers);
  }

  getInformation() {
    return of(this.jsonTest.information);
  }

  getMD5(text: string) {
    const url = this.jsonTest.servicesUrl.md5.replace('[text]', text);
    return this.httpClient.get(url);
  }

  getMyIpAddress() {
    return this.httpClient.get(this.jsonTest.servicesUrl.ip);
  }

  validateJsonData(data: {}) {
    const body = 'json=' + JSON.stringify(data);
    const httpHeaders = new HttpHeaders();
    httpHeaders.append('Content-Type', 'application/json');
    httpHeaders.append('Access-Control-Allow-Origin', '*');

    return this.httpClient.post('/api/items/add', body, {
      headers: httpHeaders
    });
  }
}